import React, { useEffect, useState } from "react";
import { Box, TextField, Typography } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { useSelector } from "../../../../store";
import { floatOnly } from "../../../../utils";

export default function WebEnumerate({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [showSymbol, setShowSymbol] = useState(data?.showSymbol ?? true);

    const [inputValue, setInputValue] = useState("");

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setShowSymbol(data?.showSymbol ?? true);
        setInputValue("");
    }, [question, 
        data?.showSymbol,
    ]);

    const handleChange = (e) => {
        if (floatOnly(e.target.value) || e.target.value === '') {
            const value = e.target.value;
            setInputValue(value);

            const canProceed = value !== "";

            onAnswer({
                canProceed,
                answer: value,
            })
        }
    };

    return (
        <Box
            sx={{
                width: "1200px",
                margin: "0 auto",
                padding: "20px",
                backgroundColor: "white",
                textAlign: "center",
            }}
        >
            <Box
                sx={{
                    borderRadius: "5px",
                    borderBottom: "10px solid rgb(91, 105, 107)",
                    backgroundColor: "rgb(122, 140, 142)",
                    padding: "10px",
                    marginBottom: "20px",
                    width: "210px",
                    margin: "0 auto",
                    textAlign: "left",
                }}
            >
                <Typography
                    variant="body1"
                    sx={{
                        color: "white",
                        marginBottom: "8px",
                        fontWeight: "bold",
                    }}
                >
                    Answer:
                </Typography>
                <TextField
                    variant="outlined"
                    type="text"
                    value={inputValue}
                    onChange={handleChange}
                    InputProps={{
                        startAdornment: showSymbol? "$" : "",
                        autoComplete: 'off',
                        style: {
                            padding: showSymbol ? "0px 4px 0px 4px" : "12px",
                            fontSize: "20px",
                        },
                        // endAdornment: ".00",
                    }}
                    sx={{
                        width: "100%",
                        backgroundColor: "white",
                        borderRadius: "5px",
                        input: {
                            padding: !showSymbol ? "0px" : "12px 4px 12px 4px",
                            fontSize: "20px",
                        },
                    }}
                />
            </Box>

            <Box>
                <Box component="img"
                    src={`${imagesResources}${data.image}`}
                    alt="Question visual"
                    style={{
                        maxWidth: "625px",
                        width: "100%", 
                        height: "auto",
                        display: "block",
                        margin: "0 auto",
                        paddingTop: "10px",
                    }}
                />
            </Box>
        </Box>
    );
};
